// Association switcher search (Super Admin). The box appears once staff have more
// than SEARCH_THRESHOLD associations to choose from.
export const SEARCH_THRESHOLD = 5;

/** Case-insensitive match on name, web address, city and state; every word must match. */
export const matchesAssociation = (association, query) => {
  const words = String(query || '').trim().toLowerCase().split(/\s+/).filter(Boolean);
  if (!words.length) return true;
  const haystack = [association.name, association.slug, association.city, association.state]
    .filter(Boolean).join(' ').toLowerCase();
  return words.every((w) => haystack.includes(w));
};
